export enum InvoiceStatus {
    Created = 'created',
    Sending = 'sending',
    Sent = 'sent',
    Failed = 'failed',
    Revoked = 'revoked',
    All = 'all',
    Preview ='preview'
}

export enum InvoiceResource {
    Agreement = 'agreement'
}

export type InvoicesListModel = {
    id: string,
    organizationId: string,
    customerName: string,
    issuerContactName: string,
    issuerName: string,
    totalGrossAmount: number,
    resourceId: string,
    resourceType: string,
    resourceName: string,
    createdAt: string,
    periodStart: string,
    periodEnd: string,
    status: string
}

export type GetInvoicesList = {
    count: number,
    results: InvoicesListModel[]
}

export type InvoiceItem = {
    description: string,
    discountPercentage: number,
    netPrice: number,
    quantity: number,
    taxPercentage: number,
    type: string
}

export type Date = {
    date: string,
    timezone: string,
    timezoneType: string
}

export type InvoicePackages = {
    name: string,
    code: string
}

export type Invoice = {
    identifier: string,
    issuer: {
        name: string,
        email: string,
        address: {
            street: string,
            zip: string,
            city: string,
            countryCode: string
        },
        vatId: string,
        businessId: string,
        bankAccount: string,
        contact: {
            name: string,
            email: string,
            address: {
                street: string,
                zip: string,
                city: string,
                countryCode: string
            }
        }
    },
    customer: {
        name: string,
        email: string,
        address: {
            street: string,
            zip: string,
            city: string,
            countryCode: string
        },
        vatId: string,
        businessId: string,
        customerNumber: string,
        contact: {
            name: string,
            email: string,
            address: {
                street: string,
                zip: string,
                city: string,
                countryCode: string
            }
        }
    },
    billing: {
        reference: string,
        packages: InvoicePackages[]
    },
    payment: {
        currency: string,
        dueDate: Date,
        penaltyPercentage: number,
        taxPercentage: number,
        termsOfPayment: number,
        totalNet: number,
        totalGross: number,
        totalTax: number
    },
    metaData: {
        resourceId: string,
        resourceType: string,
        organizationId: string,
        externalId: string,
        leadingPackage: string,
        notes: string
    },
    lines: InvoiceItem[],
    delivery: {
        method: string,
        periodStart: Date,
        periodEnd: Date,
        policy: {
            type: string,
            email: string,
            operator: string,
            address: string,
            street: string,
            zip: string,
            city: string
        }
    },
    issueDate: Date,
    createdAt: Date,
    status: string,
    description: string | null
}

export type CreateInvoice = {
    agreementId: string,
    issueDate: string,
    operatorId: string
}

export type InvoicePreviewPayload = {
    resourceId: string,
    resourceType: string,
    issueDate: string,
    operatorId: string
}

export type CreateInvoiceForAgreement = {
    agreementId: string,
    operatorId: string
    issueDate: string
}

export type ExternalLogEntry = {
    payload: any,
    response: any,
    message: string,
    responseCode: string,
    createdAt: string
}

export type InvoicingExternalLogs = {
    count: number,
    logEntries: ExternalLogEntry[]
}
